import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
import InviteStep from "./routes/InviteStep";
import { injectReducer } from "store/reducers";
const {
  invite: { path },
} = routes;
const InviteRoute = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "invite" */ "./components/Invite"),
          import(/* webpackChunkName: "invite" */ "./modules/InviteModules"),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1;
          injectReducer(store, {
            key: reducer.NAME,
            reducer: reducer.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      InviteStep(store), // place all static routes above this
    ],
  };
};
export default InviteRoute;
